module.exports = __webpack_public_path__ + "img/banner.ee11f7f7.png";